import makeRequest, {HttpMethod} from "./request";
import {setTokenTmp} from "../Storages/cookies";
import {authData, establishmentOptions, filtersData, listAdminModulesActions} from "../Storages";

const auth = makeRequest('auth').removeAuthorizationHeader().prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };

    const localData = [
        'email',
        'name',
        'user_id',
        'account_type',
        'account_products',
        'access_profile_id',
        'access_profile_modules'
    ];

    if (data?.status === "success") {
        const stringLocalData = localData.map(n => ({[n]: data[n]})).reduce((accumulator, currentValue) => ({...accumulator, ...currentValue}), {})

        authData.save(stringLocalData);

        filtersData.remove();
        establishmentOptions.remove();
        listAdminModulesActions.remove();


        if (data?.access_token) {
            setTokenTmp(data?.access_token)
        }
    }

    // filtersData.remove();

    return {
        data,
        response,
        method
    };
});

export default auth;